module.exports = __webpack_public_path__ + "img/refresh-icon.95dc841e.svg";